// extracted by mini-css-extract-plugin
export default {"container":"current-user_container__JmUQ4","user":"current-user_user__1R8h7"};